import { defineComponent as _defineComponent } from 'vue'
import {CustomerAccount, EditCustomerPayload, TableViewCustomer} from "@/models/dto";
import {computed, getCurrentInstance, ref, watch} from "vue";
import Customer from "@/services/customer";
import alert from '@/store/modules/alert'
import deepClone from "@/utils/deepClone";
import {URMRoleKey} from "@/models/dto/userRoleManagement";
import {findBestRoleForCustomerInTeam, teamRoles} from "@/utils/urmUtils";
import {AdminUserRole, AuthorizedUserRole} from "@/models/dto/UserRole";
import UserRoleSelector from "@/components/UserRoleSelector.vue";
import { phoneFormatFilter } from '@/utils/phone'


export default /*#__PURE__*/_defineComponent({
  __name: 'OrganizationTeamEditUser',
  props: {
    existingCustomer: null,
    enableUrmRoles: { type: Boolean },
    team: null
  },
  emits: ['close', 'invalid'],
  setup(__props: any, { emit: emits }) {

const props = __props as {
  existingCustomer: TableViewCustomer,
  enableUrmRoles: boolean,
  team: CustomerAccount
};




const submitting = ref<boolean>(false)
const customer = ref<EditCustomerPayload>({
  firstName: '',
  lastName: '',
  title: '',
  updatedRole: null
})
const currentUserRole = computed((): URMRoleKey | null  =>{
  return findBestRoleForCustomerInTeam(props.team.userRoles, props.existingCustomer.customerId, teamRoles)?.key
})
const selectedUserRole = ref<URMRoleKey | null>(currentUserRole.value)



watch(props.existingCustomer, (newVal) => {
  customer.value = {
    firstName: newVal.firstName,
    lastName: newVal.lastName,
    title: newVal.title,
    updatedRole: null
  }
})

const userRoles = [AdminUserRole, AuthorizedUserRole]


const updateUserRole = (roleKey: URMRoleKey) => {
  selectedUserRole.value = roleKey

  if (currentUserRole.value === roleKey) {
    customer.value.updatedRole = null
  } else {
    customer.value.updatedRole = {
      customerAccountId: props.team.customerAccountId,
      userRole: roleKey,
    }
  }
}

const cancel = () => {
  emits('close')
}

const vueInstance = getCurrentInstance()

const submit = async (): Promise<void> => {
  const form = vueInstance.proxy.$refs['edit-customer-form'] as any
  if (!form.validate()) {
    emits('invalid')
    return
  }
  const payload = deepClone(customer.value)
  submitting.value = true

  try {
    await Customer.editCustomer(props.existingCustomer.customerId, payload)
    emits('close')
  } catch (e) {
    alert.add({
      text:
        'Error editing user. Please try again later. If the problem persists, contact support.',
      color: 'error',
      title: 'Error',
      dismissible: true,
    })

    emits('close')
  }

  submitting.value = false
}

const formattedPhone = computed(() => phoneFormatFilter(props.existingCustomer.phone))


return { __sfc: true,props, submitting, customer, currentUserRole, selectedUserRole, emits, userRoles, updateUserRole, cancel, vueInstance, submit, formattedPhone, UserRoleSelector }
}

})